<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {
    // 获取用户信息
    console.log("App.vue:开始获取用户信息")
    this.$store.dispatch('getUserInfo')
  },
};
</script>


<style>
.el-image-viewer__wrapper{
  z-index: 9999 !important;
}
</style>
